export const FETCH_TRANSLATIONS = "FETCH_TRANSLATIONS";
export const FETCH_TRANSLATIONS_PENDING = "FETCH_TRANSLATIONS_PENDING";
export const FETCH_TRANSLATIONS_REJECTED = "FETCH_TRANSLATIONS_REJECTED";
export const FETCH_TRANSLATIONS_FULFILLED = "FETCH_TRANSLATIONS_FULFILLED";

export const SET_LANGUAGE = "SET_LANGUAGE";
